import $ from 'jquery'
import _ from 'lodash'
import I18n from 'i18n-js'
import SFetch from '@app/utils/sfetch'

const spinner = `<div class="sf-text sf-align-c sf-pad-v-3">
<span class="sf-spinner sf-inline-block"></span>
</div>`
const loadError = () => `<div class="sf-banner sf-banner-inline-danger">
<div class="sf-banner-icon fa fa-exclamation-triangle"></div>
<div>${I18n.t('common.error.try_again')}</div>
</div>`

let selectedRtIds = []
let initialRtIds = []
let selectedRtIdsElement

// Expose selectedRtIds globally for use in other modules
window.getSelectedRtIds = function () {
  return selectedRtIds
}

window.getInitialRtIds = function () {
  return initialRtIds
}

const fetchAutoAddedPartial = ($el, $dom) => {
  const renderTarget = $el.data('render-target')
  const linkTarget = $el.data('link-target')
  const linkTemplate = $el.data('link-template')
  const workflowId = $el.data('workflow-id')
  const reconciliationReportId = $el.val()
  const reconciliationReportName = $el.find('option:selected').text()

  if (reconciliationReportId) {
    $(renderTarget).html(spinner)

    setLink(
      linkTarget,
      linkTemplate.replace('--ID--', reconciliationReportId),
      reconciliationReportName
    )

    const params = {
      firm_id: Silverfin.currentFirmId,
      reconciliation_report_id: reconciliationReportId,
      workflow_id: workflowId,
      selected_rt_ids: selectedRtIds,
    }

    const done = (data) => {
      $(renderTarget).html(data)

      initSelectAllCheckbox($dom)
    }

    const path = params.firm_id
      ? Silverfin.Routes.auto_add_rt_form_firm_workflows_path(params)
      : Silverfin.Routes.auto_add_rt_form_partners_template_collection_accounting_workflows_path(
          params
        )

    $.get(path, done, 'html').fail(() => {
      $(renderTarget).html(loadError())
    })
  } else {
    $(renderTarget).html('')
    setLink(linkTarget, '')
  }
}

const setLink = (target, content, name) => {
  const $target = $(target)
  $target.html(content)

  const node = $target.find('a')
  node.text(node.text().replace('--NAME--', name))
}

const initSelectAllCheckbox = ($dom) => {
  const $rtCheckboxes = $dom.find(
    "[data-behaviour='workflow-rt-checkbox-item']"
  )
  const $selectAllButton = $dom.find(
    "[data-behaviour='workflow-rts-select-all']"
  )

  const notChecked = $.map($rtCheckboxes, (checkbox) =>
    $(checkbox).prop('checked')
  ).filter((v) => v === false)

  if (notChecked.length === 0) {
    $selectAllButton.prop('checked', true)
  }

  initialRtIds = $rtCheckboxes
    .toArray()
    .filter((el) => el.checked)
    .map((el) => el.value)

  $rtCheckboxes.change(function () {
    const rtIdName = JSON.parse(this.dataset['unchecked'] || '{}')
    const rtId = String(this.value)
    const $submit = $dom.find("[type='submit']")

    if (this.checked) {
      selectedRtIds.push(rtId)

      if (this.dataset['unchecked']) {
        $submit.data(
          'rts-added',
          ($submit.data('rts-added') || []).concat(rtIdName)
        )
      }
    } else {
      selectedRtIds = selectedRtIds.filter((id) => id !== rtId)

      $submit.data(
        'rts-added',
        _.reject($submit.data('rts-added') || [], ['id', rtIdName.id])
      )
    }
    // hidden element storing the list of selected RT IDs, to be submitted with the form,
    // in order to "restore" the state of the ajax-rendered RT form
    if (selectedRtIdsElement) {
      selectedRtIdsElement.value = selectedRtIds
    }

    const addedRtIds = selectedRtIds.filter((rt) => !initialRtIds.includes(rt))
    const url =
      this.dataset['url'] +
      '/fetch_selected_rts_market_packages?selected_rts=' +
      addedRtIds

    SFetch.json(url, { method: 'GET' }).then((response) => {
      if (response.length > 0) {
        document.getElementById('selected-rt-package-names').textContent =
          response.join(', ')

        document.getElementById(
          'selected-rts-market-package-banner'
        ).style.display = ''
      } else {
        document.getElementById(
          'selected-rts-market-package-banner'
        ).style.display = 'none'
      }
    })

    let confirmText = null
    if ($submit.data('rts-added') && $submit.data('rts-added').length > 0) {
      confirmText = I18n.t(
        'firm_workflows.js.newly_auto_added_reconciliations_html',
        { reconciliations: _.map($submit.data('rts-added'), 'name').join(', ') }
      )
    }
    $submit.attr('data-confirm', confirmText)
  })

  $selectAllButton.each(function () {
    const $this = $(this)
    $this.on('click', (e) => {
      $($rtCheckboxes).prop('checked', $(e.target).prop('checked')).change()
    })
  })
}

onDomLoad(function ($dom) {
  selectedRtIdsElement = document.querySelector('#selected-partner-rts')
  if (selectedRtIdsElement) {
    selectedRtIds = JSON.parse(selectedRtIdsElement.value).map((i) => String(i))
  } else {
    selectedRtIds = []
  }

  $dom
    .find(
      "[data-behaviour='accounting-workflow-reconciliation-report-dropdown']"
    )
    .each(function () {
      const $this = $(this)

      fetchAutoAddedPartial($this, $dom)

      $this.on('change', (e) => {
        fetchAutoAddedPartial($(e.target), $dom)
      })
    })
})
